import React, { Component } from 'react'
import '../css/general-style.css'

/**
 * LoadingWindow — modern full-screen loading overlay.
 *
 * Same API as before: use a ref and call showState(true/false).
 *
 *   this.ModalLoading = React.createRef();
 *   <LoadingWindow ref={this.ModalLoading} />
 *   this.ModalLoading.current.showState(true);   // show
 *   this.ModalLoading.current.showState(false);  // hide
 */
export default class LoadingWindow extends Component {

    state = {
        active: false
    }

    showState(status) {
        this.setState({ active: status });
    }

    render() {
        if (!this.state.active) return null;

        return (
            <div className="loading-overlay">
                <div className="loading-card">

                    {/* Dual-ring CSS spinner */}
                    <div className="loading-spinner" />

                    {/* Label with animated dots */}
                    <div className="loading-label">
                        Loading
                        <span className="loading-dot">.</span>
                        <span className="loading-dot">.</span>
                        <span className="loading-dot">.</span>
                    </div>

                    {/* Cancel */}
                    <button
                        className="loading-cancel"
                        onClick={() => this.showState(false)}
                    >
                        Cancel
                    </button>

                </div>
            </div>
        );
    }
}
